import { render, staticRenderFns } from "./search-bulk-contact-changes.vue?vue&type=template&id=2c5b9780&scoped=true&"
import script from "./search-bulk-contact-changes.vue?vue&type=script&lang=js&"
export * from "./search-bulk-contact-changes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b9780",
  null
  
)

export default component.exports